var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabbarHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.211,18H4.349a1.715,1.715,0,0,1-1.715-1.711L1.776,10.3H1.394c-.235,0-.468,0-.692,0a.718.718,0,0,1-.641-.468.915.915,0,0,1,.252-1L8.886.251a.857.857,0,0,1,1.212,0l8.572,8.571a.81.81,0,0,1-.459,1.463c-.308.01-.58.013-.753.013-.157,0-.251,0-.251,0l-.857,5.992A1.715,1.715,0,0,1,14.635,18h-3.85l.421-6.859a.884.884,0,0,0-.845-.854H8.641a.906.906,0,0,0-.864.854L8.211,18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarHome);
export default __webpack_public_path__ + "static/media/tabbar_home.8e162409c55a9cab481438632a139e76.svg";
export { ForwardRef as ReactComponent };